import { create, StateCreator } from 'zustand'
import { persist, devtools } from 'zustand/middleware'

interface IAccessTokenState {
    accessToken: string
    refreshToken: string
    expiresIn: number | null
}
interface IAccessTokenStore extends IAccessTokenState {
    setAccessToken: (accessToken: string) => void
    clearAccessToken: () => void
    setRefreshToken: (refreshToken: string) => void
    clearRefreshToken: () => void
    setExpiresIn: (expiresIn: number) => void
    clearExpiresIn: () => void
    reset: () => void 
}

const initialAccessTokenState: IAccessTokenState = {
    accessToken: '',
    refreshToken: '',
    expiresIn: null,
}

export const createAccessTokenStore:
    StateCreator<IAccessTokenStore, [['zustand/persist', unknown], ['zustand/devtools', never]]>
    = (set) => ({
        ...initialAccessTokenState,

        setAccessToken: (accessToken: string) => set({ accessToken }, undefined, 'AccessTokenStore/setAccessToken'),
        clearAccessToken: () => set({ accessToken: '' }, undefined, 'AccessTokenStore/clearAccessToken'),
        setRefreshToken: (refreshToken: string) => set({ refreshToken }, undefined, 'AccessTokenStore/setRefreshToken'),
        clearRefreshToken: () => set({ refreshToken: '' }, undefined, 'AccessTokenStore/clearRefreshToken'),
        setExpiresIn: (expiresIn: number) => set({ expiresIn }, undefined, 'AccessTokenStore/setExpiresIn'),
        clearExpiresIn: () => set({ expiresIn: null }, undefined, 'AccessTokenStore/clearExpiresIn'),

        reset: () => set({ ...initialAccessTokenState }, undefined, 'AccessTokenStore/reset'),
    })

export const useAccessTokenStore = create<IAccessTokenStore>()(
    persist(
        devtools(createAccessTokenStore, { name: 'AccessTokenStore' }),
        { name: 'access-token-storage' }
    )
)
